module.exports = __webpack_public_path__ + "static/media/student-success-logo.a03eba12.png";